module.exports = __webpack_public_path__ + "img/zoho.a4b8cdfc.svg";